import { TTruckerVisualizedItem } from 'services/truckerVisualized/truckerVisualized.type';
import { daysToMilliseconds } from 'utils/daysToMs';

const getItemAsJson = (key: string) => JSON.parse(localStorage.getItem(key));

const saveItem = (visualized: Map<string, TTruckerVisualizedItem>) => {
  localStorage.setItem('visualizedTruckersMapping', JSON.stringify([...visualized]));
};

const generateId = (freightId: string, vehicleId: string, user: string, personId: string | null = null) => {
  if (personId !== null) return `${user}-${freightId}-${vehicleId}-${personId}`;

  return `${user}-${freightId}-${vehicleId}`;
};

export const markAsVisualized = (
  freightId: string,
  vehicleId: string,
  user: string,
  personId: string | null = null
): void => {
  const visualizeds = getItemAsJson('visualizedTruckersMapping') ?? '';

  const visualizedAsMapping: Map<string, TTruckerVisualizedItem> = new Map(visualizeds);

  const id = generateId(freightId, vehicleId, user, personId);

  const timeToLive = parseInt(process.env.TIME_TO_LIVE_IN_DAYS, 10);

  const now = new Date().getTime();

  const item = {
    value: true,
    expiry: now + daysToMilliseconds(timeToLive),
  };

  visualizedAsMapping.set(id, item);

  saveItem(visualizedAsMapping);
};

export const isVisualized = (
  freightId: string,
  vehicleId: string,
  user: string,
  personId: string | null = null
): boolean => {
  const visualizeds = getItemAsJson('visualizedTruckersMapping') ?? false;

  if (!visualizeds) return false;

  const visualizedAsMapping = new Map(visualizeds);

  const id = generateId(freightId, vehicleId, user, personId);

  const hasVisualizedItem = visualizedAsMapping.get(id) as TTruckerVisualizedItem;

  return hasVisualizedItem?.value ?? false;
};

export const clearExpiredVisualizedEntries = (): void => {
  const visualizeds = getItemAsJson('visualizedTruckersMapping') ?? false;

  if (!visualizeds) return;

  const visualizedAsMapping: Map<string, TTruckerVisualizedItem> = new Map(visualizeds);

  const now = new Date().getTime();

  visualizedAsMapping.forEach((value, key) => {
    const { expiry } = value as TTruckerVisualizedItem;

    if (now > expiry) {
      visualizedAsMapping.delete(key);
    }
  });

  saveItem(visualizedAsMapping);
};
